import { createFileRoute, redirect } from '@tanstack/react-router';

// BSW-012 retired /admin/finance/inbox. CPH-003 collapses the redirect
// chain so /inbox lands directly on /close (was: /inbox → /transactions
// → /close).
export const Route = createFileRoute('/admin/finance/inbox')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/finance/close' });
  },
});
